import { render, staticRenderFns } from "./TeamChat.vue?vue&type=template&id=394aba18&scoped=true&"
import script from "./TeamChat.vue?vue&type=script&lang=js&"
export * from "./TeamChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394aba18",
  null
  
)

export default component.exports